<div class="request-info">
  <div>
    <div>
      <strong>{{localizeValue(langSection.RequestType, request.requestType)}}</strong>
    </div>
    <div>
      {{localizeValue(langSection.RequestCategory, request.requestCategory)}}
    </div>
  </div>
  <div>
    <div>
      {{getAlphaSlic(request.originalSlicName)}}
    </div>
    <div class="text-truncate" title="{{customName}}">
      {{customName}}
    </div>
  </div>
  @if (softDeleted && request.attentionNeeded) {
<div>
    <div style="grid-column:1/-1">
      <span class="pending-removal">{{'(' + localize(langSection.LocationList, langText.PendingRemoval) + ')' }}</span>
    </div>
  </div>
}
  @if (showPlannedTime) {
<div class="mb-2" [ngClass]="!(softDeleted && request.attentionNeeded) ? 'mt-2' : ''">
    <div class="col-lg-5">
      {{localize(langSection.TrailerCard, langText[showArriveTime ? 'ArriveTime' : 'PullTime'])}}
    </div>
    <div>
      {{plannedTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}}
      {{localizeValue(langSection.TimeZones, request.timezoneName)}}
    </div>
  </div>
}
  @if (!showPlannedTime) {
<div [ngClass]="!(softDeleted && request.attentionNeeded) ? 'mt-2' : ''">
    <div class="col-lg-5">
      {{localize(langSection.TrailerCard, langText.Earliest)}}
    </div>
    <div>
      {{request.earliestPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}}
      {{localizeValue(langSection.TimeZones, request.timezoneName)}}
    </div>
  </div>
}
  @if (!showPlannedTime) {
<div class="mb-2">
    <div>
      {{localize(langSection.TrailerCard, langText.Latest)}}
    </div>
    <div>
      {{request.latestPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}}
      {{localizeValue(langSection.TimeZones, request.timezoneName)}}
    </div>
  </div>
}
  @if (request.requestStatus === 'Pending') {
<div>
    <div>
      {{localize(langSection.FilterChip, langText.Pending)}}
    </div>
    <div>
      -
    </div>
  </div>
}
  @if (request.requestStatus === 'Approved') {
<div>
    <div>
      {{localize(langSection.TrailerCard, langText.Approved)}}
    </div>
    <div>
      -
    </div>
  </div>
}
  @if (request.requestStatus === 'Scheduled') {
<div>
    <div>
      {{localize(langSection.TrailerCard, langText.Arriving)}}
    </div>
    <div>
      {{request.scheduledPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}}
      {{localizeValue(langSection.TimeZones, request.timezoneName)}}
    </div>
  </div>
}
  @if (request.requestStatus === 'In Transit') {
<div>
    <div>
      {{localize(langSection.TrailerCard, langText.Arriving)}}
    </div>
    <div>
      {{request.arrivingPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}}
      {{localizeValue(langSection.TimeZones, request.timezoneName)}}
    </div>
  </div>
}
  @if (request.requestStatus === 'Completed' || request.requestStatus === 'On Property') {
<div>
    <div>
      {{localize(langSection.TrailerCard, langText.Arrived)}}
    </div>
    <div class="col">
      {{request.arrivalPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}}
      {{localizeValue(langSection.TimeZones, request.timezoneName)}}
    </div>
  </div>
}
  @if (request.requestStatus === 'Rejected') {
<div>
    <div>
      {{localize(langSection.FilterChip, langText.NotFulfilled)}}
    </div>
    <div>
      {{request.rejectedPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}}
      {{localizeValue(langSection.TimeZones, request.timezoneName)}}
    </div>
  </div>
}
  @if (request.requestStatus === 'Canceled') {
<div>
    <div>
      {{localize(langSection.FilterChip, langText.Canceled)}}
    </div>
    <div>
      {{request.canceledPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}}
      {{localizeValue(langSection.TimeZones, request.timezoneName)}}
    </div>
  </div>
}
  @if (request.requestStatus === 'Canceling') {
<div>
    <div>
      {{localize(langSection.FilterChip, langText.Canceling)}}...
    </div>
  </div>
}
  @if (request.requestStatus !== 'Rejected' && request.requestStatus !== 'Canceled' && request.requestStatus !== 'Canceling') {
<div
   >
    <div>
      {{localize(langSection.TrailerCard, langText.Job)}}
    </div>
    <div>
      {{request.jobNumber || "-"}}
    </div>
  </div>
}
  @if (request.requestStatus !== 'Rejected' && request.requestStatus !== 'Canceled' && request.requestStatus !== 'Canceling') {
<div
   >
    <div>
      {{localize(langSection.TrailerCard, langText.Tractor)}}
    </div>
    <div>
      {{request.tractorNumber || "-"}}
    </div>
  </div>
}
</div>